import script from "./CardSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSmall.vue?vue&type=script&setup=true&lang=js"

import "./CardSmall.vue?vue&type=style&index=0&id=13d10748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d10748"]])

export default __exports__